import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-error-message',
  template: `
    <span class="text-danger" *ngIf="control && control.touched && control.errors?.[errorKey]">
      {{ message }}
    </span>
  `,
  styles: [`
    .text-danger {
      color: red; /* Puedes personalizar este estilo según tu diseño */
      font-size: 0.85em; /* Ajusta el tamaño de la fuente si es necesario */
      margin-top: 5px;
      display: block;
    }
  `]
})
export class ErrorMessageComponent {
  @Input() control: AbstractControl | null = null;
  @Input() errorKey: string = '';
  @Input() message: string = 'Este campo es requerido.'; // Mensaje por defecto

}